import React from 'react';
import { connect } from 'react-redux';
import { shallowCheckAuthentication } from 'lib/auth';
import { isEmpty } from 'lib/util';
import heroSelector from 'selectors/heroSelector';
import selectedContentSelector from 'selectors/selectedContentSelector';
import playingContentSelector from 'selectors/playingContentSelector';
import { userLocationSelector } from 'selectors/authenticationSelectors';
import injectIntl, { intlShape } from 'common/injectIntl';
import BrandingContainer from 'branding/BrandingContainer';
import { PlayerPlacement } from 'enums';
import HeroPlaybackPage from './HeroPlaybackPage';
import ContentMetadataLarge from './ContentMetadataLarge';

const HeroPlaybackPageContainer = ({
    alertContent,
    content,
    location,
    placement,
    userAuth,
    userInitiated,
    userLocation,
    messages,
    intl: { formatMessage }
}) => {
    const formattedSubtitle = (content.type === 'event') ? `${content.source} • ${content.subtitle}` : content.subtitle;
    const subtitle = content.description ? `${formattedSubtitle} - ${content.description}` : formattedSubtitle;

    return (
        <div className="playback__columnA">
            <figure className="playback__media">
                <BrandingContainer location={location} content={content} />
                <HeroPlaybackPage
                    alertContent={alertContent}
                    content={content}
                    disableAuthPrompt={false}
                    initialAutoEmbedCountDown={0}
                    location={location}
                    playerPlacement={PlayerPlacement.PLAYBACK}
                    placement={placement}
                    userInitiated={userInitiated}
                    userLocation={userLocation}
                />
                <ContentMetadataLarge
                    userAuthenticatedForContent={shallowCheckAuthentication(content, userAuth)}
                    contentType={content.type}
                    status={content.status}
                    duration={content.duration}
                    name={content.name}
                    subtitle={subtitle}
                    liveLabel={formatMessage(messages.live)}
                />
            </figure>
        </div>
    );
};

HeroPlaybackPageContainer.propTypes = {
    alertContent: React.PropTypes.object,
    content: React.PropTypes.object,
    location: React.PropTypes.object,
    placement: React.PropTypes.string,
    userAuth: React.PropTypes.array,
    userInitiated: React.PropTypes.bool,
    userLocation: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

HeroPlaybackPageContainer.defaultProps = {
    adobePass: {},
    content: {}
};

const mapStateToProps = (state) => {
    const { authentication: { authTypes } = {} } = state;
    const selectedContent = selectedContentSelector(state);
    const content = !isEmpty(selectedContent) ? selectedContent : playingContentSelector(state);

    return {
        bucketId: state.app.selectedBucket,
        content: !isEmpty(content || {}) ? content : heroSelector(state),
        userAuth: authTypes,
        userLocation: userLocationSelector(state)
    };
};

export default connect(mapStateToProps)(injectIntl(HeroPlaybackPageContainer));



// WEBPACK FOOTER //
// ./app/page/hero/HeroPlaybackPageContainer.js